import { useState, SyntheticEvent, FC, ReactNode } from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import { makeStyles } from '@mui/styles'
import { Box } from '@mui/material'
import ExpandMoreIcon from '../../images/ExpandMoreIcon.svg'
// css style
declare module 'react' {
  interface HTMLAttributes<T> extends AriaAttributes, DOMAttributes<T> {
    accordianStyle?: object
  }
}

export interface AccordionProps {
  title?: string
  summary?: string | ReactNode
  panel?: string
  isExpanded?: boolean
  setExpanded?: Event
  onChange?: Event
  handleChange?: Event
}

const useStyles = makeStyles({
  accordianStyle: {
    padding: '8px 8px',
    minHeight: '64px',
    // marginBottom: "18px",
    boxShadow: 'none !important',
    border: 'none'
  }
})

export const AccordionComponent: FC<AccordionProps> = ({ title, summary }) => {
  const classes = useStyles()

  //accordian functionality
  const [expanded, setExpanded] = useState<string | false>(false)

  const handleChange =
    (panel: string) => (event: SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false)
    }
  return (
    <Accordion
      className={classes.accordianStyle}
      expanded={expanded === 'panel1'}
      onChange={handleChange('panel1')}
      sx={{
        backgroundColor: 'transparent'
      }}
    >
      <AccordionSummary
        expandIcon={
          <Box component='img' src={ExpandMoreIcon} alt='ExpandMoreIcon' />
        }
        aria-controls='panel1a-content'
        id='panel1a-header'
        sx={{
          p: 0,
          '.MuiAccordionSummary-expandIconWrapper.Mui-expanded ': {
            transform: 'rotate(-90deg)'
          }
        }}
      >
        <Typography
          color={'#565656'}
          align='left'
          variant='subtitle1'
          sx={{ fontWeight: 500 }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        {typeof summary === 'string' ? (
          <Typography color={'#565656'} align='left'>
            {summary}
          </Typography>
        ) : (
          summary
        )}
      </AccordionDetails>
    </Accordion>
  )
}
